import { KeycloakService } from 'keycloak-angular';
import { environment } from '../../environments/environment';

/**
 * Keycloak initialization function
 * This is called during app bootstrap to configure and initialize Keycloak
 */
export function initializeKeycloak(keycloak: KeycloakService): () => Promise<boolean> {
  return () =>
    keycloak.init({
      config: {
        url: environment.keycloak.url,
        realm: environment.keycloak.realm,
        clientId: environment.keycloak.clientId,
      },
      initOptions: {
        // Check SSO on load - try to automatically login if user has an active session
        onLoad: 'check-sso',
        // Use fragment for redirect (better for SPAs)
        responseMode: 'fragment',
        // Silent check SSO redirect URI
        silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
        // Check login iframe settings - enables silent SSO check for better UX
        // Periodically checks authentication status without full page reload
        // Set to false if experiencing issues in development
        checkLoginIframe: true,
        // Check login iframe interval (in seconds)
        checkLoginIframeInterval: 5, // Check every 5 seconds
        // Token settings
        flow: 'standard', // Use standard flow (Authorization Code Flow)
      },
      // Don't load Keycloak user profile - we get user data from our backend API
      // Loading profile requires 'account/view-profile' role and causes CORS issues
      loadUserProfileAtStartUp: false,
      // We use custom auth interceptor (auth.interceptor.ts)
      enableBearerInterceptor: false,
    });
}
